import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';


export default function RmvendorInfo(){
  const { rmvendorObj} = useSelector((state)=>state.pharmaslice.rmvendorDashboard);
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'white'}}
      >
            
        <Grid item lg={4} xs={6}><FieldView2 label="Business Id"  value={ rmvendorObj.businessid!==null && rmvendorObj.businessid!==undefined?rmvendorObj.businessid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="title"  value={ rmvendorObj.title!==null && rmvendorObj.title!==undefined?rmvendorObj.title:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Email"  value={ rmvendorObj.email!==null && rmvendorObj.email!==undefined?rmvendorObj.email:'NOT KNONWN' }/></Grid>
      </Grid>
      </Grid>
      </Box>
    )
}